// Formula strings come from our own front matter (src/_metrics/*.md), never from
// user input, so evaluating them via `Function` is safe here.
document.querySelectorAll("[data-calculator]").forEach((calc) => {
  const formula = calc.dataset.calc
  if (!formula) return

  const inputs = calc.querySelectorAll("[data-calc-input]")
  const result = calc.querySelector("[data-calc-result]")

  const format = (value) =>
    Number.isFinite(value)
      ? value.toLocaleString(undefined, { maximumFractionDigits: 2 })
      : "—"

  const recalculate = () => {
    const values = {}
    inputs.forEach((input) => {
      values[input.dataset.calcInput] = Number.parseFloat(input.value) || 0
    })

    try {
      const fn = new Function(...Object.keys(values), `return (${formula});`)
      result.textContent = format(fn(...Object.values(values)))
    } catch {
      result.textContent = "—"
    }
  }

  inputs.forEach((input) => input.addEventListener("input", recalculate))
  recalculate()
})
